<div class="alert_div">
  <div class="cancellation_guardrail">
    <div class="header">
      <mat-icon class="icon_risk" fontIcon="warning"></mat-icon>
      <h5>
        {{
          'COMPONENTS.SIDEBAR.ACCOUNT.CANCELLATION_GUARDRAIL_TITLE' | translate
        }}
      </h5>
    </div>
    <div class="content">
      {{
        'COMPONENTS.SIDEBAR.ACCOUNT.CANCELLATION_GUARDRAIL_CONTENT' | translate
      }}
    </div>
    <div class="more">
      <a (click)="openCancellationGuardrail()">{{
        'DIALOGS.QUESTION.CANCELLATION_POLICY_LEARN_MORE' | translate
      }}</a>
    </div>
  </div>
</div>
